module.exports = new __parcel__URL__("monitor-shimmer.25514da2.png").toString();